
export const CLOSE_ADD_NEW_SONG_MODAL = 'CLOSE_ADD_NEW_SONG_MODAL';
export const OPEN_ADD_SONG_TO_PLAYLIST_MODAL = 'OPEN_ADD_SONG_TO_PLAYLIST_MODAL';
export const TOGGLE_ADD_NEW_SONG_MODAL = 'TOGGLE_ADD_NEW_SONG_MODAL';

export const CLOSE_RANDOM_SONGS_LIST_MODAL = 'CLOSE_RANDOM_SONGS_LIST_MODAL';
export const OPEN_RANDOM_SONGS_LIST_MODAL = 'OPEN_RANDOM_SONGS_LIST_MODAL';
export const TOGGLE_RANDOM_SONGS_LIST_MODAL = 'TOGGLE_RANDOM_SONGS_LIST_MODAL';

export const CLOSE_USER_PLAYLISTS_MODAL = 'CLOSE_USER_PLAYLISTS_MODAL';
export const OPEN_USER_PLAYLISTS_MODAL = 'CLOSE_USER_PLAYLISTS_MODAL';
export const TOGGLE_USER_PLAYLISTS_MODAL = 'TOGGLE_USER_PLAYLISTS_MODAL';

export const CLOSE_ADD_SONG_TO_PLAYLIST_MODAL = 'CLOSE_ADD_SONG_TO_PLAYLIST_MODAL';
export const CLOSE_COUNTRY_SONGS_MODAL = 'CLOSE_COUNTRY_SONGS_MODAL';
export const CLOSE_CREATE_PLAYLIST_MODAL = 'CLOSE_CREATE_PLAYLIST_MODAL';
export const CLOSE_EDIT_SONG_MODAL = 'CLOSE_EDIT_SONG_MODAL';
export const CLOSE_REGISTRATION_MODAL = 'CLOSE_REGISTRATION_MODAL';
export const CLOSE_SEARCH_SONG_MODAL = 'CLOSE_SEARCH_SONG_MODAL';
export const CLOSE_SONG_INFO_MODAL = 'CLOSE_SONG_INFO_MODAL';
export const CLOSE_USER_CREATED_PLAYLISTS= 'CLOSE_USER_CREATED_PLAYLISTS';
export const CLOSE_USER_FAVORITE_SONGS = 'CLOSE_USER_FAVORITE_SONGS';

export const CLOSE_USER_UPLOADED_SONGS = 'CLOSE_USER_UPLOADED_SONGS';


export const OPEN_COUNTRY_SONGS_MODAL = 'OPEN_COUNTRY_SONGS_MODAL';
export const OPEN_CREATE_PLAYLIST_MODAL = 'OPEN_CREATE_PLAYLIST_MODAL';
export const OPEN_EDIT_SONG_MODAL = 'OPEN_EDIT_SONG_MODAL';
export const OPEN_SEARCH_SONG_MODAL = 'OPEN_SEARCH_SONG_MODAL';
export const OPEN_SONG_INFO_MODAL = 'OPEN_SONG_INFO_MODAL';
export const OPEN_USER_CREATED_PLAYLISTS= 'OPEN_USER_CREATED_PLAYLISTS';
export const OPEN_USER_FAVORITE_SONGS = 'OPEN_USER_FAVORITE_SONGS';

export const OPEN_USER_UPLOADED_SONGS = 'OPEN_USER_UPLOADED_SONGS';

export const SELECT_VIEW_OPTION = 'SELECT_VIEW_OPTION';

export const TOGGLE_COUNTRIES_LIST_MODAL = 'TOGGLE_COUNTRIES_LIST_MODAL';
export const TOGGLE_CREATE_PLAYLIST_MODAL = 'TOGGLE_CREATE_PLAYLIST_MODAL';
export const TOGGLE_USER_FAVORITE_SONGS = 'TOGGLE_USER_FAVORITE_SONGS';
export const TOGGLE_USER_UPLOADED_SONGS = 'TOGGLE_USER_UPLOADED_SONGS';
